angular.module("leanlaw").controller("PaymentModalController", ["$scope", "close", "payment", "client", "invoices", "leanLawApi", function ($scope, close, payment, client, invoices, leanLawApi) {
  $scope.payment = payment;
  $scope.client = client;
  $scope.total = parseFloat(invoices.reduce((sum, i) => sum + i.state.balance, 0).toFixed(2));
  $scope.invoiceString = `${invoices.length} invoice${invoices.length > 1 ? 's' : ''}`;
  leanLawApi.listAccountingMethods().then(list => {
    $scope.methods = list.methods;
  });
  $scope.confirm = function () {
    const {
      date
    } = $scope.payment;
    $scope.payment.date = new Date(date.getFullYear(), date.getMonth(), date.getDate()).toNetworkDate();
    close($scope.payment);
  };
  $scope.reject = function () {
    close(false);
  };
}]);